import script from "./wxpay.vue?vue&type=script&setup=true&lang=js"
export * from "./wxpay.vue?vue&type=script&setup=true&lang=js"

import "./wxpay.vue?vue&type=style&index=0&id=fb272cf6&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-case/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb272cf6"]])

export default __exports__